import { StyledAllieChip, TagsRowWrapper } from '../ProcessVariableCard.styles';

const MAX_VISIBLE_TAGS = 2;

interface VariableTagsRowProps {
  tags: { id: number; name: string }[];
}

export const VariableTagsRow = ({ tags }: VariableTagsRowProps) => {
  if (!tags.length) return null;

  const visible = tags.slice(0, MAX_VISIBLE_TAGS);
  const remaining = tags.length - visible.length;

  return (
    <TagsRowWrapper>
      {visible.map((tag) => (
        <StyledAllieChip
          key={tag.id}
          outline
          corner="rounded"
          title={tag.name}
          style={{ border: '1px solid var(--allie-color-neutral-30)' }}
        >
          {tag.name}
        </StyledAllieChip>
      ))}
      {remaining > 0 && (
        <StyledAllieChip
          outline
          corner="rounded"
          style={{ border: '1px solid var(--allie-color-neutral-30)' }}
        >
          +{remaining}
        </StyledAllieChip>
      )}
    </TagsRowWrapper>
  );
};
